import { withTranslation } from 'react-i18next';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import changeMyPass from '../../shared/queries/ChangeMyPass';
import GraphQL from '../../GraphQL';
import ChangeMyPassForm from './components/Form';

const ChangeMyPass = (props) => {
  const { t, dispatch, history } = props;

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const handleSubmit = (values) => {
    const mutation = changeMyPass(values);
    showLoading();
    GraphQL(mutation, {})
      .then((res) => {
        if (res.changeMyPass) {
          history.push('/minime/minha-senha');
          showNotificationAutoDestroy(
            'success',
            t('success.title'),
            t('success.successfully-saved')
          );
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('errors.error-to-change-pass')
          );
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  return <ChangeMyPassForm onSubmit={handleSubmit} />;
};

ChangeMyPass.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(ChangeMyPass)
);
